module.exports = __webpack_public_path__ + "img/invoice.79dc021c.png";